import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "tour" }
const _hoisted_2 = { class: "tour-hero" }
const _hoisted_3 = { class: "tour-hero-text" }
const _hoisted_4 = { class: "tour-title" }
const _hoisted_5 = { class: "tour-sub" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "tour-progress-top" }
const _hoisted_8 = { class: "tour-progress-bar" }
const _hoisted_9 = { class: "tour-locate-icon" }
const _hoisted_10 = { class: "tour-locate-text" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 5 }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "tour-geo-bar",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "tour-toolbar" }
const _hoisted_20 = {
  class: "dash-segment",
  role: "group",
  "aria-label": "Filtrer"
}
const _hoisted_21 = ["aria-pressed", "onClick"]
const _hoisted_22 = { class: "tour-count" }
const _hoisted_23 = { class: "tour-toolbar-right" }
const _hoisted_24 = { class: "tour-search" }
const _hoisted_25 = {
  class: "dash-segment",
  role: "group",
  "aria-label": "Affichage"
}
const _hoisted_26 = {
  key: 2,
  class: "dash-empty"
}
const _hoisted_27 = { class: "tour-map-wrap" }
const _hoisted_28 = {
  ref: "mapEl",
  class: "tour-map"
}
const _hoisted_29 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_30 = {
  key: 1,
  class: "tour-stops"
}
const _hoisted_31 = {
  class: "stop-rail",
  "aria-hidden": "true"
}
const _hoisted_32 = { class: "stop-num" }
const _hoisted_33 = {
  key: 0,
  class: "ph ph-check"
}
const _hoisted_34 = { class: "stop-body" }
const _hoisted_35 = { class: "stop-head" }
const _hoisted_36 = {
  key: 0,
  class: "stop-next"
}
const _hoisted_37 = { class: "stop-title" }
const _hoisted_38 = { class: "stop-sub" }
const _hoisted_39 = ["title"]
const _hoisted_40 = {
  key: 1,
  class: "dash-chip stop-dist is-muted"
}
const _hoisted_41 = { class: "parcel-main" }
const _hoisted_42 = { class: "parcel-line" }
const _hoisted_43 = { class: "parcel-code" }
const _hoisted_44 = {
  key: 0,
  class: "ph ph-arrows-clockwise parcel-flag",
  title: "Échange"
}
const _hoisted_45 = {
  key: 1,
  class: "ph ph-wine parcel-flag",
  title: "Fragile"
}
const _hoisted_46 = { class: "parcel-receiver" }
const _hoisted_47 = { class: "parcel-address" }
const _hoisted_48 = {
  key: 0,
  class: "parcel-note"
}
const _hoisted_49 = { class: "parcel-side" }
const _hoisted_50 = { class: "parcel-price" }
const _hoisted_51 = { class: "parcel-actions" }
const _hoisted_52 = ["href", "aria-label"]
const _hoisted_53 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/distribution-notes",
          class: "tour-back"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [
            _createElementVNode("i", {
              class: "ph ph-arrow-left",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode(" Bons distribution ", -1)
          ])),
          _: 1,
          __: [5]
        }),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "dash-eyebrow" }, "Tournée de livraison", -1)),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.note.note_ref || _ctx.refNote), 1),
        _createElementVNode("p", _hoisted_5, [
          (_ctx.note.zone_name)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.note.zone_name), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.note.note_city)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" · " + _toDisplayString(_ctx.note.note_city), 1)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.note.created_at)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode(" · " + _toDisplayString(_ctx.getDate(_ctx.note.created_at)), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", {
        class: "tour-progress",
        "aria-label": `${_ctx.doneCount} sur ${_ctx.parcels.length} colis traités`
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("b", null, _toDisplayString(_ctx.doneCount), 1),
          _createElementVNode("span", null, "/ " + _toDisplayString(_ctx.parcels.length) + " traités", 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", {
            style: _normalizeStyle({ width: _ctx.progressPct + '%' })
          }, null, 4)
        ]),
        _createElementVNode("small", null, _toDisplayString(_ctx.todoCount) + " à livrer · " + _toDisplayString(_ctx.money(_ctx.todoCash)) + " " + _toDisplayString(_ctx.$devis) + " à encaisser", 1)
      ], 8, _hoisted_6)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["tour-locate", `is-${_ctx.geoState}`])
    }, [
      _createElementVNode("span", _hoisted_9, [
        _createElementVNode("i", {
          class: _normalizeClass(_ctx.geoState === 'ok' ? 'ph ph-navigation-arrow' : _ctx.geoState === 'pending' ? 'ph ph-crosshair' : 'ph ph-map-pin-line'),
          "aria-hidden": "true"
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.geoState === 'ok')
          ? (_openBlock(), _createElementBlock("b", _hoisted_11, "Trié du plus proche au plus loin depuis votre position"))
          : (_ctx.geoState === 'pending')
            ? (_openBlock(), _createElementBlock("b", _hoisted_12, "Localisation en cours…"))
            : (_openBlock(), _createElementBlock("b", _hoisted_13, "Position indisponible : tri par ville et quartier")),
        (_ctx.geocoding)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Localisation des quartiers " + _toDisplayString(_ctx.geoDone) + "/" + _toDisplayString(_ctx.geoTotal) + "…", 1))
          : (_ctx.geoState === 'denied')
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "Autorisez la localisation dans le navigateur pour trier par proximité."))
            : (_ctx.unlocatedStops)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.unlocatedStops) + " arrêt(s) non localisé(s), placés en fin de liste.", 1))
              : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary tour-locate-btn",
        disabled: _ctx.geoState === 'pending',
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.locate && _ctx.locate(...args)))
      }, _cache[7] || (_cache[7] = [
        _createElementVNode("i", {
          class: "ph ph-arrows-clockwise",
          "aria-hidden": "true"
        }, null, -1),
        _createElementVNode("span", null, "Actualiser ma position", -1)
      ]), 8, _hoisted_17)
    ], 2),
    (_ctx.geocoding)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("span", {
            style: _normalizeStyle({ width: (_ctx.geoTotal ? (_ctx.geoDone / _ctx.geoTotal) * 100 : 0) + '%' })
          }, null, 4)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterOptions, (opt) => {
          return (_openBlock(), _createElementBlock("button", {
            key: opt.key,
            type: "button",
            class: _normalizeClass(["dash-segment-btn", { active: _ctx.filter === opt.key }]),
            "aria-pressed": _ctx.filter === opt.key,
            onClick: ($event: any) => (_ctx.filter = opt.key)
          }, [
            _createTextVNode(_toDisplayString(opt.label) + " ", 1),
            _createElementVNode("span", _hoisted_22, _toDisplayString(opt.count), 1)
          ], 10, _hoisted_21))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("label", _hoisted_24, [
          _cache[8] || (_cache[8] = _createElementVNode("i", {
            class: "ph ph-magnifying-glass",
            "aria-hidden": "true"
          }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
            type: "search",
            class: "form-control",
            placeholder: "Code, client, téléphone, adresse…"
          }, null, 512), [
            [_vModelText, _ctx.search]
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["dash-segment-btn", { active: _ctx.view === 'list' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.view = 'list'))
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("i", {
              class: "ph ph-list-numbers",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode(" Liste ", -1)
          ]), 2),
          _createElementVNode("button", {
            type: "button",
            class: _normalizeClass(["dash-segment-btn", { active: _ctx.view === 'map' }]),
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showMap && _ctx.showMap(...args)))
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("i", {
              class: "ph ph-map-trifold",
              "aria-hidden": "true"
            }, null, -1),
            _createTextVNode(" Carte ", -1)
          ]), 2)
        ])
      ])
    ]),
    (_ctx.isLoader)
      ? (_openBlock(), _createBlock(_component_AppLoader, {
          key: 1,
          variant: "skeleton",
          rows: 5
        }))
      : (_ctx.loadError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _cache[11] || (_cache[11] = _createElementVNode("i", {
              class: "ph ph-cloud-slash",
              "aria-hidden": "true"
            }, null, -1)),
            _cache[12] || (_cache[12] = _createElementVNode("p", null, "Impossible de charger les colis de ce bon.", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.load && _ctx.load(...args)))
            }, "Réessayer")
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _withDirectives(_createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, null, 512),
              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "tour-map-hint" }, "Positions approximatives (centre du quartier).", -1))
            ], 512), [
              [_vShow, _ctx.view === 'map']
            ]),
            (_ctx.view === 'list' && !_ctx.visibleStops.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _cache[14] || (_cache[14] = _createElementVNode("i", {
                    class: "ph ph-package",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createElementVNode("p", null, _toDisplayString(_ctx.parcels.length ? "Aucun colis ne correspond." : "Aucun colis dans ce bon."), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.view === 'list')
              ? (_openBlock(), _createElementBlock("ol", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleStops, (stop) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: stop.key,
                      class: _normalizeClass(["stop", { 'is-done': stop.allDone, 'is-next': stop.key === _ctx.nextStopKey }])
                    }, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("span", _hoisted_32, [
                          (stop.allDone)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(stop.order), 1)
                              ], 64))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("header", _hoisted_35, [
                          _createElementVNode("div", null, [
                            (stop.key === _ctx.nextStopKey)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Prochain arrêt"))
                              : _createCommentVNode("", true),
                            _createElementVNode("h2", _hoisted_37, _toDisplayString(stop.district || stop.city || "Adresse inconnue"), 1),
                            _createElementVNode("p", _hoisted_38, [
                              (stop.district && stop.city)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(stop.city) + " · ", 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(stop.parcels.length) + " colis ", 1),
                              (stop.cash)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" · " + _toDisplayString(_ctx.money(stop.cash)) + " " + _toDisplayString(_ctx.$devis), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (stop.legKm != null)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "dash-chip stop-dist",
                                title: stop.order === 1 ? 'Depuis votre position' : 'Depuis l\'arrêt précédent'
                              }, [
                                _cache[15] || (_cache[15] = _createElementVNode("i", {
                                  class: "ph ph-path",
                                  "aria-hidden": "true"
                                }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.formatKm(stop.legKm)), 1)
                              ], 8, _hoisted_39))
                            : (!stop.coords)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_40, "Non localisé"))
                              : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stop.parcels, (parcel) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: parcel.id,
                            class: _normalizeClass(["parcel", { 'is-done': _ctx.isDone(parcel) }])
                          }, [
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("b", _hoisted_43, _toDisplayString(parcel.code), 1),
                                _createElementVNode("span", {
                                  class: "parcel-status",
                                  style: _normalizeStyle({ '--st': _ctx.statusOf(parcel).color })
                                }, _toDisplayString(_ctx.statusOf(parcel).name), 5),
                                (parcel.replace == 1)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_44))
                                  : _createCommentVNode("", true),
                                (parcel.fragile == 1)
                                  ? (_openBlock(), _createElementBlock("i", _hoisted_45))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_46, _toDisplayString(parcel.receiver || "—"), 1),
                              _createElementVNode("div", _hoisted_47, [
                                _cache[16] || (_cache[16] = _createElementVNode("i", {
                                  class: "ph ph-map-pin",
                                  "aria-hidden": "true"
                                }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(parcel.address || "Adresse non renseignée"), 1)
                              ]),
                              (parcel.note)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                    _cache[17] || (_cache[17] = _createElementVNode("i", {
                                      class: "ph ph-chat-text",
                                      "aria-hidden": "true"
                                    }, null, -1)),
                                    _createTextVNode(" " + _toDisplayString(parcel.note), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _createTextVNode(_toDisplayString(_ctx.money(parcel.price)) + " ", 1),
                                _createElementVNode("small", null, _toDisplayString(_ctx.$devis), 1)
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                (parcel.phone)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      class: "parcel-btn",
                                      href: `tel:${parcel.phone}`,
                                      "aria-label": `Appeler ${parcel.receiver || ''}`,
                                      title: "Appeler"
                                    }, _cache[18] || (_cache[18] = [
                                      _createElementVNode("i", {
                                        class: "ph ph-phone",
                                        "aria-hidden": "true"
                                      }, null, -1)
                                    ]), 8, _hoisted_52))
                                  : _createCommentVNode("", true),
                                _createElementVNode("a", {
                                  class: "parcel-btn is-primary",
                                  href: _ctx.directionsUrl(parcel),
                                  target: "_blank",
                                  rel: "noopener",
                                  "aria-label": "Itinéraire",
                                  title: "Itinéraire"
                                }, _cache[19] || (_cache[19] = [
                                  _createElementVNode("i", {
                                    class: "ph ph-navigation-arrow",
                                    "aria-hidden": "true"
                                  }, null, -1)
                                ]), 8, _hoisted_53)
                              ])
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ], 2))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 64))
  ]))
}